// extracted by mini-css-extract-plugin
module.exports =  {"alert":"lKFMaluPL7uWA_Si5Q1q"};